module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px",
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length === 0
    },
    on: {
      "click": _vm.openBatchEdit
    }
  }, [_vm._v("批量编辑类型")]), _vm._v(" "), (_vm.selectedRows.length) ? _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("\n          已选 " + _vm._s(_vm.selectedRows.length) + " 个一级菜单\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.visibleRows
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "selectable": function (row) { return row.level === 1; },
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "菜单名称",
      "min-width": "340"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          style: ({
            display: 'inline-block',
            width: (scope.row.level - 1) * 24 + 'px',
          })
        }), _vm._v(" "), (scope.row.hasChildren) ? _c('i', {
          staticClass: "el-icon-caret-right expand-icon",
          class: {
            expanded: scope.row.expanded
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.toggleExpand(scope.row)
            }
          }
        }) : _c('i', {
          staticClass: "el-icon-caret-right",
          staticStyle: {
            "visibility": "hidden"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.node.title || scope.row.node.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.node.campusScope === 1 ? 'success' : 'warning',
            "close-transition": ""
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.node.campusScope === 1 ? "默认开放" : "指定学校开放") + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已配置学校",
      "width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.level === 1 && scope.row.node.campusScope === 2) ? _c('span', {
          staticClass: "link-count",
          on: {
            "click": function($event) {
              return _vm.openSchoolList(scope.row, 'applied')
            }
          }
        }, [_vm._v(_vm._s(scope.row.node.campusAppliedCount || 0))]) : _c('span', [_vm._v("—")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已屏蔽学校",
      "width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.level === 1 && scope.row.node.campusScope === 1) ? _c('span', {
          staticClass: "link-count",
          on: {
            "click": function($event) {
              return _vm.openSchoolList(scope.row, 'blocked')
            }
          }
        }, [_vm._v(_vm._s(scope.row.node.campusBlockedCount || 0))]) : _c('span', [_vm._v("—")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.level === 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openSingleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _c('span', [_vm._v("—")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editDialog.isBatch ? '批量编辑类型' : '编辑类型',
      "modal-append-to-body": false,
      "width": "540px"
    },
    model: {
      value: (_vm.editDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.editDialog, "visible", $$v)
      },
      expression: "editDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用类型"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.editDialog.campusScope),
      callback: function($$v) {
        _vm.$set(_vm.editDialog, "campusScope", $$v)
      },
      expression: "editDialog.campusScope"
    }
  }, [_vm._v("默认开放")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.editDialog.campusScope),
      callback: function($$v) {
        _vm.$set(_vm.editDialog, "campusScope", $$v)
      },
      expression: "editDialog.campusScope"
    }
  }, [_vm._v("指定学校开放")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px",
      "margin": "-20px 20px 20px 20px"
    }
  }, [(_vm.editDialog.campusScope === 1) ? [_vm._v("\n          默认开放：所有学校默认可见（含后续新增学校），仅所选学校被屏蔽（不选则全部可见）。\n        ")] : [_vm._v("\n          指定学校开放：仅所选学校可见，至少选择一所学校。\n        ")]], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.editDialog.campusScope === 1 ?
        '屏蔽学校（选填）' :
        '开放学校（必选）'
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "请选择学校"
    },
    model: {
      value: (_vm.editDialog.selectedSchools),
      callback: function($$v) {
        _vm.$set(_vm.editDialog, "selectedSchools", $$v)
      },
      expression: "editDialog.selectedSchools"
    }
  }, _vm._l((_vm.allSchools), function(s) {
    return _c('el-option', {
      key: s.rootUnid,
      attrs: {
        "label": s.name,
        "value": s.rootUnid
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.confirmEdit
    }
  }, [_vm._v("确认修改")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.schoolListDialog.title,
      "modal-append-to-body": false,
      "width": "480px"
    },
    model: {
      value: (_vm.schoolListDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.schoolListDialog, "visible", $$v)
      },
      expression: "schoolListDialog.visible"
    }
  }, [(_vm.schoolListDialog.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "24px",
      "color": "#999"
    }
  }, [_vm._v("\n      加载中...\n    ")]) : [_c('el-input', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "placeholder": "搜索学校",
      "clearable": ""
    },
    model: {
      value: (_vm.schoolListDialog.keyword),
      callback: function($$v) {
        _vm.$set(_vm.schoolListDialog, "keyword", $$v)
      },
      expression: "schoolListDialog.keyword"
    }
  }), _vm._v(" "), (_vm.schoolListDisplay.length) ? _c('div', {
    staticStyle: {
      "max-height": "320px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.schoolListDisplay), function(name, i) {
    return _c('div', {
      key: i,
      staticStyle: {
        "padding": "10px 4px",
        "border-bottom": "1px solid #f0f0f0"
      }
    }, [_vm._v("\n          " + _vm._s(name) + "\n        ")])
  }), 0) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "24px",
      "color": "#999"
    }
  }, [_vm._v("\n        暂无学校\n      ")])], _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.schoolListDialog.visible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d733742!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/UniversityManage/MenuManage/MenuManage.vue
// module id = 1110
// module chunks = 0